import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../stores/auth";

const PrivateRoute = () => {
  const { accessToken } = useAuth()
  const location = useLocation()
  return (
    accessToken ? <Outlet /> : <Navigate to='/login' state={{ from: location }} />
  )
}

export default PrivateRoute